import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=0b06b558&scoped=true&"
import script from "./TextArea.vue?vue&type=script&lang=ts&"
export * from "./TextArea.vue?vue&type=script&lang=ts&"
import style0 from "./TextArea.vue?vue&type=style&index=0&id=0b06b558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b06b558",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QField});
